import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class UIManagerService {
    disableSummaryDashboard: boolean = false;
    reset() {
        this.disableSummaryDashboard = true;
    }
}
